// Заявки › batch actions (plan §4.4). A wizard run is one batch_id; the owner approves or
// pauses the whole thing, which is the unit a decision was actually made about.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isConfigured, isDemoMode, supabase } from '../../lib/supabase.js';

export type BatchAction = 'approve' | 'pause';

export function useBatchAction() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ batchId, action }: { batchId: string; action: BatchAction }) => {
      if (!isConfigured || isDemoMode) return;
      const patch =
        action === 'approve'
          ? { active: true, approved_at: new Date().toISOString() }
          : { active: false };
      const { error } = await supabase.from('search_queries').update(patch).eq('batch_id', batchId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['search_queries'] });
      void client.invalidateQueries({ queryKey: ['vertical_counts'] });
    },
  });
}
